import { Assignee } from 'infrastructure/enums';

import type { TFunction } from 'i18next';
import type { RpmOverviewPatient } from 'infrastructure/hooks/rpm/overview-dashboard';
import type { IAssignTool } from 'infrastructure/interfaces';
import type { FiltersCount } from 'infrastructure/hooks/rpm/overview-dashboard/use-assignee-filters-count';

export const getPatientAssignees = (
  patientsData: RpmOverviewPatient[],
  assignedPatients: IAssignTool[],
): RpmOverviewPatient[] => {
  const assigneeMap = new Map(
    assignedPatients.map((patient) => [patient.guid, patient.assignee]),
  );

  return patientsData.map((patient) => {
    const assignee = assigneeMap.get(patient.guid);

    if (assignee) {
      return {
        ...patient,
        assignee,
      };
    }

    return patient;
  });
};

export const getAssigneeFilters = (
  t: TFunction,
  filtersCount?: FiltersCount,
) => [
  {
    key: Assignee.All,
    label: t('labels.all'),
    count: filtersCount?.all ?? 0,
  },
  {
    key: Assignee.Free,
    label: t('labels.freeToAssign'),
    count: filtersCount?.freeToAssign ?? 0,
  },
  {
    key: Assignee.Me,
    label: t('labels.assignedToMe'),
    count: filtersCount?.assignedToMe ?? 0,
  },
];
